import { Link } from 'react-router-dom';
import Breadcrumb from '@/components/base/Breadcrumb';

const values = [
  {
    icon: 'ri-focus-3-line',
    title: '内容为先',
    desc: '不追逐流量标题，只写值得被认真阅读的剧情解读与影评。每一条观点都尽量做到有理有据。',
  },
  {
    icon: 'ri-chat-smile-2-line',
    title: '尊重多元',
    desc: '电影没有唯一答案。我们欢迎不同角度的声音，也鼓励读者带着自己的理解去观看。',
  },
  {
    icon: 'ri-eye-line',
    title: '保持诚实',
    desc: '本站内容均为演示数据，所有片名、影评与资讯皆为虚构示例，用于展示影视资讯站点的形态。',
  },
];

const team = [
  { name: '内容编辑部', role: '剧情解读与影评', desc: '负责电影的剧情梳理、主题分析与观点整理。' },
  { name: '资讯组', role: '影视资讯与观察', desc: '跟踪新片动态、行业观察与主创访谈类内容。' },
  { name: '运营组', role: '站点体验与维护', desc: '负责站点的内容组织、栏目规划与阅读体验优化。' },
];

export default function About() {
  return (
    <div className="w-full">
      <section className="bg-primary-950 text-background-50">
        <div className="max-w-content mx-auto px-4 md:px-6 py-10 md:py-16">
          <Breadcrumb
            className="mb-5 [&_a]:text-background-200/80 [&_a:hover]:text-accent-400 [&_span]:text-background-50"
            items={[{ label: '首页', to: '/' }, { label: '关于我们' }]}
          />
          <h1 className="text-2xl md:text-4xl font-bold">关于聚会的目的电影</h1>
          <p className="mt-4 max-w-3xl text-sm md:text-base text-background-200/85 leading-relaxed">
            我们是一个专注影视内容解读的小站点，以电影《聚会的目的》为起点，
            希望为影迷提供一个能安静看剧情、读影评、追资讯的地方。
          </p>
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-10 lg:gap-16 items-start">
          <div>
            <div className="flex items-center gap-3">
              <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
              <h2 className="text-xl md:text-2xl font-bold text-foreground-950">我们做什么</h2>
            </div>
            <div className="mt-5 space-y-4 text-base leading-8 text-foreground-700">
              <p>
                本网站围绕电影《聚会的目的》及其相关作品展开，提供三类核心内容：
                详尽的<span className="font-semibold text-foreground-900">剧情介绍</span>，
                多角度的<span className="font-semibold text-foreground-900">专业影评</span>，
                以及及时的<span className="font-semibold text-foreground-900">影视资讯</span>。
              </p>
              <p>
                我们希望帮助观众在观影前后都能更懂一部电影——理解人物关系、发现隐藏细节、
                看到不同的解读，也了解一部作品在行业中的位置。
              </p>
              <p>
                站点不提供在线播放、下载、会员或付费功能。我们相信，好的内容解读本身，
                就足以让一次观影变得更完整。
              </p>
            </div>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            {[
              { num: '12+', label: '收录电影' },
              { num: '36+', label: '精选影评' },
              { num: '10+', label: '资讯文章' },
              { num: '2024', label: '站点上线年份' },
            ].map((s) => (
              <div
                key={s.label}
                className="p-6 rounded-lg bg-background-100 border border-background-200"
              >
                <p className="text-2xl md:text-3xl font-bold text-primary-600 tabular-nums">{s.num}</p>
                <p className="mt-1 text-sm text-foreground-500">{s.label}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 border-y border-background-200">
        <div className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="flex items-center gap-3">
            <span className="w-1.5 h-7 rounded-full bg-accent-500"></span>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950">我们的坚持</h2>
          </div>
          <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
            {values.map((v) => (
              <div key={v.title} className="p-6 rounded-lg bg-background-50 border border-background-200">
                <span className="w-12 h-12 rounded-md bg-primary-50 text-primary-600 flex items-center justify-center">
                  <i className={`${v.icon} text-2xl`}></i>
                </span>
                <h3 className="mt-4 text-base font-semibold text-foreground-950">{v.title}</h3>
                <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{v.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="flex items-center gap-3">
          <span className="w-1.5 h-7 rounded-full bg-primary-500"></span>
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950">团队与愿景</h2>
        </div>
        <p className="mt-4 max-w-3xl text-base leading-8 text-foreground-700">
          我们是一个由影迷组成的小团队。愿景很简单：让每一次观影之后，都有地方可以继续说下去。
        </p>
        <div className="mt-6 grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {team.map((t) => (
            <div key={t.name} className="p-6 rounded-lg bg-background-50 border border-background-200">
              <h3 className="text-base font-semibold text-foreground-950">{t.name}</h3>
              <p className="mt-1 text-sm text-primary-600 font-medium">{t.role}</p>
              <p className="mt-2 text-sm text-foreground-500 leading-relaxed">{t.desc}</p>
            </div>
          ))}
        </div>
      </section>

      <section className="max-w-content mx-auto px-4 md:px-6 pb-16">
        <div className="p-6 md:p-8 rounded-lg bg-secondary-50 border border-secondary-200">
          <div className="flex items-start gap-3">
            <i className="ri-copyright-line text-secondary-600 text-xl w-6 h-6 flex items-center justify-center mt-0.5"></i>
            <div>
              <h2 className="text-base font-semibold text-foreground-950">版权与免责声明</h2>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">
                本站为影视内容演示站点，站内所有影片信息、剧情介绍、影评观点与资讯文章均为虚构示例，
                不代表任何真实作品或人物。站点不提供、也不链接任何影视播放资源。
                如本站内容涉及版权问题，请通过
                <Link to="/contact" className="mx-1 text-primary-600 hover:text-primary-700 font-medium">
                  联系我们
                </Link>
                页面与我们取得联系，我们将第一时间处理。
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}